import { render, staticRenderFns } from "./shift-penalty-modal.vue?vue&type=template&id=5bf7de91&scoped=true"
import script from "./shift-penalty-modal.vue?vue&type=script&lang=js"
export * from "./shift-penalty-modal.vue?vue&type=script&lang=js"
import style0 from "./shift-penalty-modal.vue?vue&type=style&index=0&id=5bf7de91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf7de91",
  null
  
)

export default component.exports